/** API route map: URLS.Controller.Reports */
export const Reports = {
      Name: 'Reports',
      CandidateStatusCount: 'candidate-status-count',
      OnlineApplicantJobsCount: 'online-applicant-jobs-count',
      CandidateStatusReport: 'get-candidate-status-report',
      OnlineApplicantReport: 'get-online-applicant-report',
      CandidateAssessmentReport: 'get-candidate-assessment-report',
      GetAllJobs: 'get-all-jobs',
      GetAllClients: 'get-client-names-list',
      GetAllEmployeesByClient: 'get-employee-names-by-client',
      GetAllCandidateDroppedReport: 'get-candidate-dropped-report',
      GetAllJobPipelineReport: 'get-job-pipeline-report',
      GetAllJobRequisitionReport: 'get-job-requisition-report',
      GetAllClientPipelineReport: 'get-client-pipeline-report',
      GetClientStatus: 'get-client-status',
      GetJobStatus: 'get-job-status',
      GetJobRequisitionStatus: 'get-job-requisition-status',
      GetAllJobHiringReport: 'get-job-hiring-report',
      GetToFillFill: 'get-all-time-to-fill-report',
      GetCandidateSourcing: 'candidates-sourcing-report',
      GetClientIndustry: 'client-industry-report',
      GetCandidatePlacement: 'candidates-placement-report',
      WebsiteAndSocialListeningReport: 'get-website-and-social-listening-report',
      EmpTurnOverRatioReport: 'employee-turn-over-ratio',
      GetAllJobRequisitionJobs: 'get-job-request-job-names',
      GetClientIndustries: 'get-client-industries',
      GetInvoiceAgingReport: 'client-invoice-aging-report',
      GetClientPayGroups: 'get-client-pay-groups',
      GetClientsPayGroups: 'get-clients-pay-groups',
      GetClientPayPeriods: 'get-client-pay-periods',
      GetClientInvoicePayPeriods: 'get-client-invoice-pay-periods',
      GetClientPtoPolicies: 'get-client-pto-policies',
      PayrollSummaryReport: 'payroll-summary-report',
      PayrollSummaryReportPills: 'payroll-summary-report-pills',
      PayrollEmployeeEarningReport: 'payroll-employee-earning-report',
      PayrollEmployeeEarningReportPills: 'payroll-employee-earning-report-pills',
      PayrollDeductionReport: 'payroll-deduction-report',
      PayrollDeductionReportPills: 'payroll-deduction-report-pills',
      PayrollPaycheckRegisterReport: 'payroll-paycheck-register-report',
      PayrollEmployeePTOAccrualReport: 'payroll-employee-pto-accrual-report',
      PayrollInvoiceVarianceReport: 'payroll-invoice-variance-report',
      PayrollBillRateReport: 'payroll-bill-rate-report',
      PayrollBillRateReportPills: 'payroll-bill-rate-report-pills',
      PayrollInvoiceVarianceReportPills: 'payroll-invoice-variance-report',
      GetAllWCCodeReport: 'wc-code-report',
      GetEmployeeCensusDetails: 'get-employee-census-report-details',
      GetBenefitRulesReport: 'benefit-rules-report',
      GetBenefitGroupDetails: 'benefit-group-report',
      GetBenefitBillingDetail: 'benefit-billing-detail-report',
      RunPayrollSummaryReport: 'run-payroll-summary-report',
      RunPayrollBillRateReport: 'run-payroll-bill-rate-report',
      RunPayrollDeductionReport: 'run-payroll-deduction-report',
      RunPayrollEmployeeEarningReport: 'run-payroll-employee-earning-report',
      RunPayrollPaycheckRegisterReport: 'run-payroll-paycheck-register-report',
      PayrollRegisterReport: 'payroll-register-report',
      PayrollRegisterReportDetail: 'payroll-register-report-detail',
      GetInvoiceRegister: 'payroll-invoice-register',
      PayrollWorkerCompensationExportReport: 'payroll-worker-compensation-export-report',
      PayrollDeductionCodeSummaryReport: 'payroll-deduction-Code-summary-report',
      GetBenefitEmployeeDeductionDetails: 'get-benefit-employee-deduction-details',
      PayrollWorkerCompensationExportReportFilter:
        'payroll-worker-compensation-export-report-filter',
};
